(function () {
  var roots = document.querySelectorAll(".mega-bazar");
  if (!roots.length) return;

  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }

  roots.forEach(function (root) {
    var rot = root.querySelector("[data-mb-rot]");
    var sec = root.querySelector("[data-mb-contador]");
    var timer = root.querySelector("[data-mb-timer]");
    var diasEl = root.querySelector("[data-mb-dias]");
    var horasEl = root.querySelector("[data-mb-horas]");
    var minEl = root.querySelector("[data-mb-min]");
    var startRaw = sec ? sec.getAttribute("data-start") : "";
    var endRaw = sec ? sec.getAttribute("data-end") : "";

    if (rot && sec && timer && diasEl && horasEl && minEl && startRaw && endRaw) {
      var inicio = new Date(startRaw);
      var fim = new Date(endRaw);

      function tick() {
        var now = new Date();
        var alvo;
        var texto;

        if (now < inicio) {
          alvo = inicio;
          texto = "Faltam para começar";
        } else if (now <= fim) {
          sec.classList.add("agora");
          rot.innerHTML = '<span class="pulse"></span>Acontecendo agora — termina em';
          alvo = fim;
        } else {
          rot.textContent = "O Mega Bazar terminou — até a próxima!";
          timer.hidden = true;
          return;
        }

        if (now < inicio) rot.textContent = texto;

        var diff = Math.max(0, alvo - now);
        diasEl.textContent = String(Math.floor(diff / 86400000));
        horasEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        minEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      }

      tick();
      setInterval(tick, 30000);
    }

    var car = root.querySelector(".hero-carrossel");
    if (!car) return;

    var slides = Array.prototype.slice.call(car.querySelectorAll(".slide-mb"));
    var dotsWrap = car.querySelector(".mb-dots");
    var liveRegion = car.querySelector("[data-mb-live]");
    if (slides.length < 2 || !dotsWrap) return;

    var idx = 0;
    var timerId;
    var wasManuallyPaused = false;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function setLive(rotating) {
      if (liveRegion) liveRegion.setAttribute("aria-live", rotating ? "off" : "polite");
    }

    slides.forEach(function (slide, i) {
      var button = document.createElement("button");
      button.type = "button";
      button.setAttribute("role", "tab");
      button.setAttribute("aria-selected", i === 0 ? "true" : "false");
      button.setAttribute("aria-label", "Ir para o banner " + (i + 1));
      if (i === 0) button.className = "on";
      button.addEventListener("click", function () {
        ir(i);
        wasManuallyPaused = true;
        parar();
      });
      dotsWrap.appendChild(button);
    });

    var dots = Array.prototype.slice.call(dotsWrap.children);

    function ir(n) {
      slides[idx].classList.remove("ativo");
      slides[idx].setAttribute("aria-hidden", "true");
      dots[idx].classList.remove("on");
      dots[idx].setAttribute("aria-selected", "false");
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add("ativo");
      slides[idx].setAttribute("aria-hidden", "false");
      dots[idx].classList.add("on");
      dots[idx].setAttribute("aria-selected", "true");
    }

    function iniciar() {
      if (reduceMotion || wasManuallyPaused) return;
      parar();
      timerId = setInterval(function () {
        ir(idx + 1);
      }, 8000);
      setLive(true);
    }

    function parar() {
      clearInterval(timerId);
      timerId = null;
      setLive(false);
    }

    var nextBtn = car.querySelector(".next");
    var prevBtn = car.querySelector(".prev");

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        ir(idx + 1);
        wasManuallyPaused = true;
        parar();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        ir(idx - 1);
        wasManuallyPaused = true;
        parar();
      });
    }

    car.addEventListener("mouseenter", parar);
    car.addEventListener("mouseleave", function () {
      if (!wasManuallyPaused) iniciar();
    });
    car.addEventListener("focusin", parar);
    car.addEventListener("focusout", function (event) {
      if (!car.contains(event.relatedTarget) && !wasManuallyPaused) iniciar();
    });

    iniciar();
  });
})();
